function goPage(path, history) {
  history.push(path);
  const contentArea = document.getElementById('content-area');
  contentArea.scroll(0, 0);
}

export { goPage };
